import { esc } from '../ui/icons.js';
import { dados, estadoEmpresa } from '../state.js';

/**
 * ===================================================================
 * BALANCETE E COMPOSIÇÃO DE SALDOS — FORA DA v1 (decisão da Beatriz)
 * ===================================================================
 * Estes dados vêm do Domínio. Enquanto não existir a importação, as duas
 * telas continuam com os MESMOS números ilustrativos do protótipo, para
 * não quebrar o layout.
 *
 * NÃO use estes valores para nada real. Quando a importação entrar,
 * este arquivo inteiro sai e os dados passam a vir do Supabase.
 * ===================================================================
 */

const BALANCETE_EXEMPLO = [
  { cod: '1.1.01', cls: 'Ativo Circulante', desc: 'Caixa', ant: 2140.00, deb: 8900.00, cred: 8420.00, atual: 2620.00 },
  { cod: '1.1.02', cls: 'Ativo Circulante', desc: 'Bancos Conta Movimento', ant: 41230.50, deb: 112400.00, cred: 98650.30, atual: 54980.20 },
  { cod: '1.1.03', cls: 'Ativo Circulante', desc: 'Aplicações Financeiras', ant: 55120.10, deb: 2100.73, cred: 382.00, atual: 56838.83 },
  { cod: '1.1.04', cls: 'Ativo Circulante', desc: 'Clientes', ant: 78400.00, deb: 64200.00, cred: 71100.00, atual: 71500.00 },
  { cod: '2.1.01', cls: 'Passivo Circulante', desc: 'Fornecedores', ant: 32100.00, deb: 28900.00, cred: 31200.00, atual: 34400.00 },
  { cod: '2.1.02', cls: 'Passivo Circulante', desc: 'Impostos a Recolher', ant: 9800.00, deb: 9800.00, cred: 11200.00, atual: 11200.00 },
  { cod: '2.2.01', cls: 'Patrimônio Líquido', desc: 'Capital Social', ant: 100000.00, deb: 0, cred: 0, atual: 100000.00 },
  { cod: '2.2.02', cls: 'Patrimônio Líquido', desc: 'Lucros Acumulados', ant: 48900.30, deb: 0, cred: 5200.00, atual: 54100.30 },
];

const COMPOSICOES_EXEMPLO = [
  { conta: 'Aplicações Financeiras', saldoBalancete: 56838.83, itens: [
    { item: 'Aplicação Itaú', origem: 'Extrato', valor: 22400.00, conf: true },
    { item: 'Kinea Dakar', origem: 'Extrato', valor: 18938.83, conf: true },
    { item: 'CDB Itaú', origem: 'Extrato', valor: 15500.00, conf: true },
  ] },
  { conta: 'Fornecedores', saldoBalancete: 34400.00, itens: [
    { item: 'Distribuidora Alfa Ltda', origem: 'NF em aberto', valor: 12400.00, conf: true },
    { item: 'Transportes Beta', origem: 'NF em aberto', valor: 9800.00, conf: true },
    { item: 'Suprimentos Gama', origem: 'NF em aberto', valor: 11200.00, conf: false },
  ] },
];

const AVISO = `<p style="font-size:12px;color:var(--amber-text);background:var(--amber-bg);padding:9px 12px;border-radius:8px;margin:0 0 14px;">
  Dados de exemplo. A importação do Domínio ainda não foi implementada — não use estes valores.
</p>`;

const brl = (v) => v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function configurar() {
  document.getElementById('balEmpresa').addEventListener('change', renderBalancete);
  document.getElementById('balPeriodo').addEventListener('change', renderBalancete);
}

export function preencherSelect() {
  const sel = document.getElementById('balEmpresa');
  const atual = sel.value;
  sel.innerHTML = dados.empresas.map((e) => `<option value="${e.id}">${esc(e.nome)}</option>`).join('');
  if ([...sel.options].some((o) => o.value === atual)) sel.value = atual;
}

export function renderBalancete() {
  const corpo = document.querySelector('#balTable tbody');
  corpo.innerHTML = BALANCETE_EXEMPLO.map((r) => `
    <tr><td>${r.cod}</td><td>${r.cls}</td><td>${r.desc}</td>
    <td class="num-cell">${brl(r.ant)}</td><td class="num-cell">${brl(r.deb)}</td>
    <td class="num-cell">${brl(r.cred)}</td><td class="num-cell"><b>${brl(r.atual)}</b></td></tr>`).join('');

  const tabela = document.getElementById('balTable');
  if (!tabela.previousElementSibling?.classList.contains('aviso-exemplo')) {
    const aviso = document.createElement('div');
    aviso.className = 'aviso-exemplo';
    aviso.innerHTML = AVISO;
    tabela.parentElement.insertBefore(aviso, tabela);
  }
}

export function renderComposicao() {
  document.getElementById('compList').innerHTML = AVISO + COMPOSICOES_EXEMPLO.map((c, i) => {
    const total = c.itens.reduce((s, it) => s + it.valor, 0);
    const dif = +(c.saldoBalancete - total).toFixed(2);
    const conferido = Math.abs(dif) < 0.01;
    return `<div class="comp-card">
      <div class="comp-summary" data-idx="${i}">
        <div><div class="cname">${c.conta}</div><div class="csaldo">Saldo do balancete: R$ ${brl(c.saldoBalancete)}</div></div>
        <span class="tag ${conferido ? 'green' : 'red'}">${conferido ? 'Conferido' : 'Divergência'}</span>
      </div>
      <div class="comp-detail" id="compDetail${i}">
        <table><thead><tr><th>Item</th><th>Origem</th><th class="num-cell">Valor</th><th>Conferido</th></tr></thead>
        <tbody>${c.itens.map((it) => `<tr><td>${it.item}</td><td>${it.origem}</td><td class="num-cell">${brl(it.valor)}</td><td>${it.conf ? '✓' : '—'}</td></tr>`).join('')}</tbody></table>
        <div class="comp-diff"><span>Saldo do balancete: R$ ${brl(c.saldoBalancete)} · (−) Composição: R$ ${brl(total)}</span><b>Diferença: R$ ${brl(dif)}</b></div>
      </div>
    </div>`;
  }).join('');

  document.querySelectorAll('.comp-summary').forEach((s) =>
    s.addEventListener('click', () =>
      document.getElementById('compDetail' + s.dataset.idx).classList.toggle('show')
    )
  );
}

/* ------------------------------------------------------------------ */
/* Relatórios — estes SÃO reais, calculados dos dados do Supabase      */
/* ------------------------------------------------------------------ */

export function renderRelatorios() {
  const relatorios = [
    { t: 'Empresas com pendências', n: dados.empresas.filter((e) => estadoEmpresa(e) === 'a_realizar').length,
      d: 'Documentos, Open Finance ou balancete travando o fechamento.' },
    { t: 'Itens de conferência sinalizados', n: dados.sinalizados.length,
      d: 'Itens em Parcial ou Pendente nas competências abertas.' },
    { t: 'Empresas em andamento', n: dados.empresas.filter((e) => estadoEmpresa(e) === 'andamento').length,
      d: 'Fechamento sendo trabalhado no momento.' },
    { t: 'Competências em aberto', n: dados.empresas.filter((e) => e.competencia_aberta).length,
      d: 'Empresas com pelo menos um mês ainda não concluído.' },
    { t: 'Tarefas em aberto', n: dados.tarefas.filter((t) => t.status !== 'Concluído').length,
      d: 'Prazo vencido ou próximo do vencimento.' },
    { t: 'Pesquisas registradas', n: dados.pesquisas.length,
      d: 'Dúvidas resolvidas — evita retrabalho.' },
    { t: 'Realizado do dia', n: dados.realizado.length,
      d: 'Atividades registradas hoje pela equipe.' },
  ];

  document.getElementById('reportGrid').innerHTML = relatorios.map((r) => `
    <div class="report-card"><p class="t">${r.t}</p><p class="n">${r.n}</p><p class="d">${r.d}</p></div>`).join('');
}
